import { CalculateOutlined, ContentCopyOutlined, EditOutlined } from "@mui/icons-material";
import { Alert, AlertTitle, Box, Button, Container, Stack, Typography } from "@mui/material";
import {
    ListDetailViewSectionContent,
    ListDetailViewSectionHeader,
    ListDetailViewSectionLayout,
} from "../../components/ListDetailView";
import { useUserInfo } from "../../utils/security";
import { PricelistItems } from "./PricelistItems";

export const PricelistsDetail = ({
    data,
    loading,
    onEditPricelist,
    onShowRecurringDialog,
    onBack,
    ...others
}) => {
    const { userInfo, hasRight } = useUserInfo();
    console.log("data", data);

    return (
        <ListDetailViewSectionLayout loading={loading}>
            <ListDetailViewSectionHeader
                onBack={onBack}
                title={data?.name}
                titleLoading={loading}
                loading={loading}
                role="overview"
                actions={[
                    {
                        title: "Vytvořit kopii...",
                        icon: <ContentCopyOutlined />,
                        onClick: ({ id, ...data }) => onEditPricelist?.({ ...data, _copyOf: id }),
                    },
                    {
                        title: "Vytvořit cenovou nabídku...",
                        icon: <CalculateOutlined />,
                        onClick: undefined,
                    },
                    {
                        title: "Upravit",
                        icon: <EditOutlined />,
                        onClick: () => onEditPricelist?.(data),
                    },
                    /*
                    {
                        title: "Nastavit oprávnění...",
                        icon: <KeyOutlined />,
                        onClick: onShowRecurringDialog,
                    },
                */
                ]}
            />
            <ListDetailViewSectionContent>
                {/*<PeriodField />*/}
                <Container maxWidth="xl">
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 4, py: 4 }}>
                        <Alert severity="info">
                            <AlertTitle>Informace</AlertTitle>
                            <Stack direction="row" spacing={1}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    startIcon={<CalculateOutlined />}
                                    onClick={() => onEditPricelist?.(data)}>
                                    Přidat cenovou nabídku
                                </Button>
                            </Stack>
                        </Alert>

                        <Typography variant="body1" component="div">
                            TODO "editor"
                        </Typography>

                        <PricelistItems items={data?.items} />
                    </Box>
                </Container>
            </ListDetailViewSectionContent>
        </ListDetailViewSectionLayout>
    );
};
